<template>
<div>
  <Modal class="modal-reg" width="524" v-model="modal3" :closable="false" :mask-closable="false" :footer-hide="true">
       <div slot="header" class="modal-reg-title">
            欢迎成为娃娃鱼供应商<Icon  type="md-close" @click="closeReg"/>
       </div>
      <div class="modal-reg-body">
           <Row>
           <Col style="display:flex;">
           <div style="position:relative;">
            <span>手机号码</span>
              <p class="country-title" @click="isCountry=!isCountry">{{countries}}<Icon type="ios-arrow-down" /></p>
               <ul class="country" v-if="isCountry">
                    <li v-for="(item,index) in allCountries" @click="chooseCountry(item[2])" :key="index">{{item[0] + item[2] }}</li>
                </ul>
            <input type="text" style="width:156px;" v-model="Tel">
           
           </div>
            <Button type="info" :disabled="isdisabled" @click="getCode">获取验证码
                <span v-if="isdisabled">{{Time}}s</span>
            </Button>
           </Col>
       </Row>
       <Row>
           <Col>
           <span>重置密码</span>
            <input v-model="password" type="password">
            <!-- <Icon type="ios-checkmark-circle" /> -->
            <!-- <Icon type="ios-close-circle" /> -->
           </Col>
       </Row>
        <Row>
           <Col>
           <span>验证码</span>
            <input type="text" v-model="code">
            <Icon type="ios-close-circle" v-if="isFlag==2" />
            <Icon type="ios-checkmark-circle" v-if="isFlag==1" />
           </Col>
       </Row>
       <button class="btn" @click="regSubmit">重置密码</button>
      </div>
    </Modal>
</div>
</template>
<script>
export default {
    props:{
        modal3:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return{
            Tel:'',
            password:'',
            code:'',
            allCountries:this.$allCountries,
            countries:'86',
            Time:60,
            isCountry:false,
            isdisabled:false,
            isFlag:0,//检验验证码是否正确
        }
    },
    mounted(){
      console.log(this.modal3)
    },
    methods:{
      chooseCountry(code){
            this.countries=code;
            this.isCountry=false;
        },
         getCode(){
            var params={
                type:2,
                Tel:this.Tel,
                TelCode:this.countries,//区号
            }
            if(this.Tel&&this.countries){
                this.$post('api/Login/sendCode',params).then(res=>{
                                if(res.code==1){
                                     this.isdisabled=true;
                            var timer= setInterval(()=>{
                                this.Time--;
                                if(this.Time==0){
                                    this.Time=60;
                                    this.isdisabled=false;
                                    clearInterval(timer)
                                }shiyin
                                },1000)
                                    this.$Message.success(res.msg);
                                }else{
                                    this.$Message.error(res.msg);
                                }
                            })
            }else{
                this.$Message.error('请填写正确的手机号码')
            }
        },
        regSubmit(){//重置密码
        // /^1[3456789]\d{9}$/.test(Tel)
          var params={
                Tel:this.Tel,
                Password:this.password,
                code:this.code,
                 TelCode:this.countries,//区号
            }
            if(this.Tel&&this.countries){
            this.$post('api/login/forgetPassword',params).then(res=>{
                if(res.code==1){
                    this.$Message.success('重置密码成功，请登录！');
                     this.$emit('click',false)
                }else{
                    if(res.msg=='验证码已经失效，请重新发送！'||res.msg=='验证码输入有误，请重新输入！'){
                        this.isFlag=2;
                    }else{
                        this.isFlag=1;
                    }
                    this.$Message.error(res.msg);
                }
            })
            }else{
                this.$Message.error('请填写正确的手机号码')
            }
           
        },
        cancel(){
            console.log('test')
        },
        closeReg(){
            this.$emit('closePsw',false)
        }
    }
}
</script>
<style lang="less" scoped>
.modal-reg{
     text-align: center;
  .modal-reg-title{
        background-color:#F0F2F1;
        text-align: center;
        padding:20px;
        color: #AAAAAA;
        font-size: 20px;
        i{
            float: right;
            font-size: 25px;
            cursor: pointer;
        }
    }
    .modal-reg-body{
        padding:0px 46px;
    }
    .ivu-row{
        border-bottom:1px solid #E8EAE9;
        margin:20px 0px;
        .ivu-col{
            display: flex;
            >div{
                >span{
                    width: 74px;
                text-align: left;
                height: 50px;
                line-height: 50px;
                }
            }
            >span{
                width: 74px;
                text-align: left;
                height: 50px;
                line-height: 50px;
            }
            input{
              width: 220px;
              border:none;
            }
            .ivu-icon{
                font-size: 25px;
                color: #D81E06;
                 margin-left: 106px;
                 margin-top: 10px;
            }
              .country-title{
                  width: 72px;
                margin-top: 16px;
                display: flex;
                i{
                    color: #000;
                        margin-left: 0;
                        margin-top: 0;
                        font-size: 20px;
                        margin-left: 10px;
                }
            }
            .ivu-icon-ios-checkmark-circle{
                color: #5BB531;
            }

        }
        
    }
    .ivu-row:nth-child(1){
        border:none;
        .ivu-col{
             div{  
                 display: flex;
              border-bottom:1px solid #E8EAE9;
             }
             .ivu-btn-info{
                 margin-left: 26px;
                 margin-top: 20px;
             }
        }
        
    }
    .btn{
        width: 422px;
        height: 37px;
        color: #fff;
        background-color: #056DC2;
        text-align: center;
        border:none;
        margin-top: 50px;
        margin-bottom:100px;
       

    }
}
  .country{
                position: absolute;
                left: 52px;
                top: 37px;
                z-index: 999;
                width: 200px;
                background-color: #fff;
                border: 1px solid #eee;
                height: 300px;
                overflow-y: scroll;
                li{
                    line-height: 30px;
                  cursor: pointer;
                }
        }
    
</style>



// WEBPACK FOOTER //
// src/components/findPsw-modal.vue